module.exports = __webpack_public_path__ + "media/packs/images/flags/MY-90351cfee7745327d9329105826f6d6e.png";